module.exports = __webpack_public_path__ + "static/check-e95730ca4b5af9a45941fc58725d6f68.jpg";